// extracted by mini-css-extract-plugin
module.exports = {"root":"Status_root__KnmyN","approved":"Status_approved__iur9B","rejected":"Status_rejected__sXJU8","expired":"Status_expired__3-0P9","label":"Status_label__3YWoD"};